import React, { useState, useEffect, useCallback } from 'react'
import { activateUser, handleDirectLogin, handleTinyUrl, updateNewPassword } from '../../api/user/login-api'
import { SystemError } from '../error/SystemError'
import { useRouter } from 'next/router'
import { validateLink } from '../../api/user/change-request-api'
import { setLocalStorageEmail, setLocalStorageJwtToken, setLocalStorageLoginToken } from '../../js/localstorage'
import { LoadingCover } from '../commons/LoadingCover'
import { spWelcomeEmail } from '../../api/email/email-api';
import { iosLogin } from '../../api/firebase/firebase';

export const HandleTinyUrl = () => {
    const router = useRouter()
    const query = router.query
    
    const [ redirectUrl, setRedirectUrl] = useState("")
    const [ isSubmit, setIsSubmit ] = useState(false)   
    const [ isSystemError, setIsSystemError ] = useState(false)
    const [ errorContent, setErrorContent ]  = useState({'header': "", 'body': ""}); 
    

    const callNativeApp = (email) => {
        return new Promise((resolve) => {
            try {
                const fcmToken = window.iosFCMToken || '';
                if (fcmToken && fcmToken.trim() !== '') {
                    iosLogin(email, fcmToken)
                        .then(() => console.log('IosLogin success'))
                        .catch(err => console.log('IosLogin error:', err));
                }
                if (typeof webkit !== 'undefined' && webkit.messageHandlers && webkit.messageHandlers.callbackHandler) {
                    webkit.messageHandlers.callbackHandler.postMessage(email);
                }
                setTimeout(resolve, 500);
            } catch(err) {
                console.log('callNativeApp error:', err.message);
                resolve();
            }
        });
    }

    const sendSpWelcomeEmail = useCallback(async(email) => {
        try {
            await spWelcomeEmail(email)            
        } catch (error) {
            console.log(error);
            setIsSubmit(false);
        }
    }, [])

    const loginDirect = useCallback(async() => {
        setIsSubmit(true)
        try {
            let response = await handleDirectLogin(query.directLoginId, query.directLoginEmail)
            
            if (response.message === "successful"){
                setLocalStorageEmail(response.userEmail);
                setLocalStorageLoginToken(response.loginToken);
                setLocalStorageJwtToken(response.jwtToken);

                if (typeof android != "undefined"){
                    android.showToast(response.userEmail);
                }
                await callNativeApp(response.userEmail);                
                router.push(query.redirectPath).then(() => setIsSubmit(false) );
            } else {
                setIsSubmit(false);
                router.push("/")
            }
        } catch (error) {
            console.log(error);
            setErrorContent({ 'header': "Error Activating Account", 'body': "Please try again. If problem persists, contact us at support@stringssg.com" });
            setIsSystemError(true);
            setIsSubmit(false);
        }
    }, [query, router])

    useEffect(() => {
        if(!query.directLoginId || !query.directLoginEmail) return

        loginDirect()

    }, [loginDirect, query])

    useEffect(() => {
        if(!redirectUrl) return
        globalThis.location.href = redirectUrl
    }, [redirectUrl])

    const handleUrl = useCallback(async() => {
        setIsSubmit(true)
        try {
            let response = await handleTinyUrl(query.tinyUrlId)
            setIsSubmit(false)
            setRedirectUrl(response.redirectUrl)
        } catch (error) {
            console.log(error);
            setIsSubmit(false)
        }
    }, [query.tinyUrlId])

    useEffect(() => {
        if(!query.tinyUrlId) return
        handleUrl()
    }, [query, handleUrl])

  return (
    <>
        
        {isSystemError && <SystemError errorContent={errorContent} setIsSystemError={setIsSystemError}/>}
        {isSubmit &&
            <LoadingCover/>
        }
    </>
  )
}
